export default {
    patentReview: {
        list: {
            title: 'Review Tasks',
            newTask: '+ New Review',
            empty: 'No review tasks yet',
            emptyHint: 'Upload a patent draft file to start a formal review',
            rules: 'rules',
            tabTasks: 'Task List',
            tabRules: 'Custom Rules',
        },
        status: {
            pending: 'Pending',
            running: 'Running',
            completed: 'Completed',
            failed: 'Failed',
        },
        steps: {
            '1_parsing': 'Parse file',
            '2_extracting': 'Extract elements',
            '3_figure_analysis': 'Figure Analysis',
            '4_formal_check': 'Formal Review',
            '5_substantive_check': 'Substantive Review',
            '6_finalizing': 'Final Report',
        },
        stepStatus: {
            done: 'Done',
            running: 'Running',
            failed: 'Failed',
            pending: 'Pending',
        },
        consistencyStep: {
            title: 'Disclosure Consistency',
        },
        stabilityStep: {
            title: 'Stability Analysis',
        },
        upload: {
            title: 'New Review Task',
            mainFile: {
                title: 'Upload draft application',
                hint: 'PDF, DOCX',
            },
            figureSection: {
                addButton: 'Figures',
                title: 'Figures',
                hint: 'Drag and drop or select multiple files',
            },
            disclosureSection: {
                addButton: 'Disclosure',
                title: 'Disclosure',
                hint: 'Drag and drop or select multiple files',
            },
            customRulesSection: {
                addButton: 'Custom Rules',
                title: 'Custom Rules',
                dialogTitle: 'Custom Rule Library',
                searchPlaceholder: 'Search rule library name',
                historyGroup: 'Previously Uploaded',
                newGroup: 'Uploaded This Time',
                uploadButton: 'Upload Rules',
                uploadFormats: 'Supports .docx / .pdf / .pptx',
                confirm: 'Confirm Selection',
                empty: 'No rule libraries yet. Click "Upload Rules" to add one',
                rulesEmpty: 'No rules were extracted from this library',
                loadFailed: 'Failed to load rule libraries, please retry',
                uploadFailed: 'Failed to upload the rule file, please retry',
            },
            patentOffice: 'Patent Office',
            officeHint: 'Switching auto-matches the applicable statutes and examination guidelines',
            officeComingSoon: 'Coming soon',
            patentType: {
                label: 'Patent Type',
                invention: 'Invention',
                utility: 'Utility Model',
            },
            ruleType: {
                label: 'Rule Type',
                official: 'Official Rules',
                officialCustom: 'Official + Custom Rules',
            },
            chooseFile: 'Choose File',
            fileHint: 'Supports .docx / .pdf, up to {max} files',
            confirm: 'Start Review',
            uploading: 'Uploading…',
            cancel: 'Cancel',
            removeFile: 'Remove',
        },
        detail: {
            backToList: 'Back to list',
            taskHeader: {
                entry: 'Formal Review',
                projectPackage: 'Patent Review Project Package',
                unnamedTask: 'Untitled task',
                progressTitle: 'Review Progress',
                autoRun: 'Auto-run',
                exportReport: 'Export Report',
                exportNotReady: 'Available once the review is complete',
                finalizingCardSubtitle: 'Summary conclusion',
                stepsExecutedCaption: '4 processes executed',
                parsingCaption: 'Parsing…',
                issueCountSuffix: '{count} issues',
            },
            materials: {
                mainFileTag: 'Patent application',
                figureTag: 'Figures',
                disclosureTag: 'Disclosure',
                attachmentTag: 'Attachment',
            },
            parsing: {
                fileName: 'File name',
                fileNamePending: 'Identifying the main file…',
                hint: 'Parsing the uploaded file…',
            },
            extracting: {
                title: 'Title',
                abstract: 'Abstract',
                claims: 'Claims',
                specification: 'Specification',
                figures: 'Figures',
                expand: 'Expand',
                collapse: 'Collapse',
                empty: 'No content',
            },
            check: {
                pass: 'Pass',
                passCollapsed: 'Passed ({count})',
                filterAll: 'All',
                filterInfo: 'Info',
                filterWarning: 'Warning',
                filterError: 'Error',
                filterCritical: 'Critical',
                location: 'Location',
                suggestion: 'Suggestion',
                guidelineSource: 'Guideline source',
                empty: 'No formal check issues',
                summaryPattern: 'Found {count} formal or enterprise-standard issues that can be located',
                statTitle: 'Found {count} formal issues: {officialCount} against official rules, {customCount} against enterprise rules.',
                statFormalIssues: 'Formal issues',
                statOfficialViolations: 'Against official rules',
                statCustomViolations: 'Against enterprise rules',
                summaryTitle: 'Formal Check Summary',
                summaryRequireModify: '{count} items require revision',
                summaryRequireConfirm: '{count} items require manual confirmation',
                summaryStats: '{total} total rules · {requireModify} items · {requireConfirm} items · {pass} items passed',
                systemRules: 'System Rules',
                customRules: 'Enterprise Rules',
                legendPass: 'Passed',
                legendFail: 'Failed',
                legendPending: 'Requires manual confirmation',
                summaryAllPassed: 'All passed',
                coverageTitle: 'Rule coverage',
                coverageSource: 'Rule source',
                coverageTotal: 'Rules',
                coverageFail: 'Failed',
                coverageVerify: 'Needs review',
                coveragePending: 'Pending verification',
                coveragePassed: 'Passed',
            },
            table: {
                tabIssues: 'Issue Locations',
                tabCoverage: 'Check Coverage',
                sourceOfficial: 'Official Rules',
                sourceCustom: 'Custom Rules',
                sourceCustomEmpty: 'No custom rule matches yet',
                searchPlaceholder: 'Search claims, issues or statutes',
                columnIndex: '#',
                columnLocation: 'Location',
                columnIssue: 'Check result / Issue',
                columnStatute: 'Applicable statute / Rule basis',
                columnSuggestion: 'Suggestion',
                columnEvidence: 'Evidence',
                evidenceEmpty: '—',
                statusPending: 'Needs revision',
                statusApplied: 'Revised',
                statusIgnored: 'Ignored',
                statusPass: 'Passed',
                coverageColumnType: 'Rule type',
                coverageColumnRule: 'Rule checked',
                coverageColumnContent: 'Rule content',
                coverageColumnResult: 'Check result',
                coverageResultEmpty: '—',
                coverageResultFound: 'Issue found',
                ruleTypeOfficial: 'Official rule',
                ruleTypeCustom: 'Enterprise rule',
                itemUnit: 'items',
                columnPatentChapter: 'Patent Chapter',
                columnCheckRule: 'Check Rule',
                columnCheckResult: 'Check Result',
                columnErrorReason: 'Error Reason',
                editButton: 'Edit',
                adoptButton: 'Adopt Revision',
                locateButton: 'Locate Error',
                locationModalTitle: 'Error Location',
                locationModalContent: 'Location: {location}',
                locationModalClose: 'Close',
                locationModalRuleLabel: 'Check Rule',
                locationModalLocationLabel: 'Location',
                locationModalSuggestionLabel: 'Suggestion',
                locationModalBoundaryLabel: 'Applicable boundary',
                locationModalSourceTitle: 'Source Content',
                locationModalPositionUnresolved: 'Unable to determine error position',
                statusRequireModify: 'Requires revision',
                statusRequireConfirm: 'Requires manual confirmation',
                statusPendingVerification: 'Pending verification',
            },
            finalizing: {
                conclusion: 'Overall conclusion',
                totalRules: 'Total rules',
                passCount: 'Pass',
                warningCount: 'Warning',
                errorCount: 'Error',
                criticalCount: 'Critical',
                conclusions: {
                    formal: 'Formal check conclusion',
                    art26_3: 'Article 26.3 conclusion',
                    art26_4: 'Article 26.4 conclusion',
                },
                riskMatrix: {
                    title: 'Substantive review risk distribution',
                    high: 'High risk',
                    medium: 'Medium risk',
                    low: 'Low risk',
                },
                conclusionValue: {
                    compliant: 'Compliant',
                    risky: 'Basically compliant with risk',
                    non_compliant: 'Possibly non-compliant',
                    insufficient: 'Insufficient material for a full determination',
                },
                dimensionConclusions: {
                    title: 'Dimension conclusions',
                    unresolved: 'Not determined',
                },
            },
            featureMapping: {
                figuresNone: 'This application contains no figures',
                figuresFailed: 'Figure recognition did not complete; this assessment did not incorporate figure content',
                figureNoLabel: 'Figure {no}',
                figureNoUnknown: 'Figure number not labeled',
                figureConfidenceMedium: 'Figure number inferred',
                figureConfidenceLow: 'Figure number undetermined',
                figureSignsLabel: 'Reference signs',
                figureNoSigns: 'No reference signs visible',
            },
            substantive: {
                filterHigh: 'High risk',
                filterMedium: 'Medium risk',
                filterLow: 'Low risk',
                filterAll: 'All',
                needsInventorConfirm: 'Needs inventor confirmation',
                boundaryLabel: 'Applicable boundary',
                summaryPattern: 'Found {count} substantive issues, review each one carefully',
                issuesLocations: 'Formal issue locations',
                title: 'Substantive Review',
                checkResultTitle: 'Check Result',
                issuesCount: 'Substantive issues',
                highRiskCount: 'High risk issues',
            },
            supplement: {
                title: 'Necessary supplementary materials',
                columns: {
                    content: 'Content to supplement',
                    reason: 'Reason',
                    targetStatute: 'Target statute',
                    suggestedLocation: 'Suggested location',
                },
                empty: 'No supplementary materials',
            },
            failed: {
                retryHint: 'The review task failed. Go back to the list to re-upload.',
            },
            reportLoadFailed: {
                message: 'Failed to load the review report, please retry',
                retry: 'Retry',
            },
            stepRunning: 'This step is running. Results will appear once it completes…',
            noStepSelected: 'Select a step to view its details',
        },
        customRuleDocuments: {
            delete: 'Delete',
            deleteConfirm: 'Delete this?',
            confirmYes: 'Confirm',
            confirmNo: 'Cancel',
            empty: 'No rule documents yet',
            rulesEmpty: 'No rules were extracted from this document',
            rulesLoadFailed: 'Failed to load rule details, please retry',
            rulesCount: '{count} rules',
            status: {
                uploaded: 'Uploaded',
                parsing: 'Parsing',
                parsed: 'Parsed',
                parse_failed: 'Parse failed',
            },
            upload: {
                title: 'Upload Rule Document',
                addButton: 'Upload Rule Document',
                fileTitle: 'Upload rule document',
                fileHint: 'PDF, DOCX',
                chooseFile: 'Choose File',
                removeFile: 'Remove',
                confirm: 'Upload',
                uploading: 'Uploading…',
            },
            loadFailed: 'Failed to load rule documents, please retry',
            uploadFailed: 'Failed to upload rule document, please retry',
            updateFailed: 'Failed to update, please retry',
            deleteSuccess: 'Deleted successfully',
            deleteFailed: 'Failed to delete, please retry',
        },
        errors: {
            createTaskFailed: 'Failed to create the review task, please retry',
            loadTaskFailed: 'Failed to load task status, please retry',
            loadReportFailed: 'Failed to load the review report, please retry',
            loadTasksFailed: 'Failed to load the task list, please retry',
            unsupportedOffice: 'This patent office is not currently supported',
            exportReportFailed: 'Failed to export the review report, please retry',
        },
    },
};
